import { startOfMonth as fnsStartOfMonth, formatISO } from 'date-fns'

export const startOfMonth = (dateStr: string): string => {
  return formatISO(fnsStartOfMonth(new Date(dateStr)))
}
